export default __webpack_public_path__ + "static/media/flesh2.d545e7d6.png";